import React, { useEffect, useRef } from "react";
import { CropperFade } from "react-advanced-cropper";
import Spinner from "./icons/Spinner";
import Navigation from "../navigation/Navigation";
import "./CropperWrapper.css";

const CropperWrapper = ({
  cropper,
  children,
  className,
  spinnerClassName,
  navigation,
  navigationProps = {},
}) => {
  const navigationRef = useRef(null);

  const state = cropper.getState();
  const transitions = cropper.getTransitions();
  const { rotate } = cropper.getTransforms();

  useEffect(() => {
    navigationRef.current?.refresh();
  }, [state?.boundary.width, state?.boundary.height]);

  return (
    <div
      className={`telegram-cropper-wrapper ${
        navigation ? "telegram-cropper-wrapper--with-navigation" : ""
      } ${className || ""}`}
    >
      <CropperFade
        className={"telegram-cropper-wrapper__fade"}
        visible={cropper.isLoaded()}
      >
        {children}
        {navigation && (
          <Navigation
            ref={navigationRef}
            value={rotate}
            onRotate={cropper.rotateImage}
            onRotateEnd={cropper.transformImageEnd}
            onFlip={cropper.flipImage}
            className={`telegram-cropper-wrapper__navigation ${
              navigationProps.className || ""
            }`}
            buttonClassName={navigationProps.buttonClassName}
            barClassName={navigationProps.barClassName}
            valueBarClassName={navigationProps.valueBarClassName}
            zeroBarClassName={navigationProps.zeroBarClassName}
            highlightedBarClassName={navigationProps.highlightedBarClassName}
            disabled={transitions.active}
          />
        )}
      </CropperFade>
      <Spinner
        className={`telegram-cropper-wrapper__spinner ${
          cropper.isLoading()
            ? "telegram-cropper-wrapper__spinner--visible"
            : ""
        } ${spinnerClassName || ""}`}
      />
    </div>
  );
};

export default CropperWrapper;